import api from './api';

export interface TaskBezug {
  company?: { id: string; name: string; domain?: string | null } | null;
  lead?: { id: string; email: string; firstName?: string | null; lastName?: string | null } | null;
  deal?: { id: string; title: string; value: number; currency: string } | null;
  activity?: { id: string; type: string; campaignName?: string | null; occurredAt: string } | null;
  assignee?: { id: string; name: string } | null;
}

export interface Task extends TaskBezug {
  id: string;
  title: string;
  description?: string | null;
  /** todo | call | email | meeting */
  kind: string;
  /** low | normal | high */
  priority: string;
  /** open | done | cancelled */
  status: string;
  dueAt?: string | null;
  doneAt?: string | null;
  companyId?: string | null;
  leadId?: string | null;
  dealId?: string | null;
  activityId?: string | null;
  assigneeId?: string | null;
  createdAt: string;
}

export interface Tagesansicht {
  ueberfaellig: Task[];
  heute: Task[];
  woche: Task[];
  ohneTermin: Task[];
  summe: { offen: number; ueberfaellig: number; heute: number };
}

export interface TaskEingabe {
  title: string;
  description?: string;
  kind?: string;
  priority?: string;
  dueAt?: string | null;
  companyId?: string;
  leadId?: string;
  dealId?: string;
  activityId?: string;
  assigneeId?: string;
}

const taskService = {
  async heute(): Promise<Tagesansicht> {
    const response = await api.get('/tasks/heute');
    return response.data;
  },

  async list(filter?: {
    status?: string; assigneeId?: string; companyId?: string; dealId?: string; nurFaellig?: boolean;
  }): Promise<Task[]> {
    const response = await api.get('/tasks', { params: filter || {} });
    return response.data;
  },

  async create(daten: TaskEingabe): Promise<Task> {
    const response = await api.post('/tasks', daten);
    return response.data;
  },

  async update(id: string, daten: Partial<TaskEingabe> & { status?: string }): Promise<Task> {
    const response = await api.patch(`/tasks/${id}`, daten);
    return response.data;
  },

  async erledigen(id: string, erledigt = true): Promise<Task> {
    const response = await api.post(`/tasks/${id}/erledigen`, { erledigt });
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/tasks/${id}`);
  },

  /** Liegengebliebene Antworten nachtraeglich zu Aufgaben machen. */
  async ausAntworten(fristStunden?: number): Promise<{ geprueft: number; neu: number; schonDa: number }> {
    const response = await api.post('/tasks/aus-antworten', { fristStunden });
    return response.data;
  },
};

export default taskService;
